export const customIcons = [
  // Transportation
  {
    key: "\uE803",
    name: "Car",
    keywords: ["Auto", "Fahrzeug", "Wagen", "car", "vehicle", "automobile"],
  },
  {
    key: "\uE804",
    name: "Taxi",
    keywords: ["Taxi", "Cab", "Mietwagen", "taxi", "cab", "hire car"],
  },
  {
    key: "\uE805",
    name: "Truck",
    keywords: ["Lastwagen", "LKW", "Transporter", "truck", "lorry", "van"],
  },
  {
    key: "\uE821",
    name: "Bus",
    keywords: ["Bus", "Omnibus", "Autobus", "bus", "coach", "omnibus"],
  },
  {
    key: "\uE837",
    name: "Bus",
    keywords: ["Bus", "Omnibus", "Autobus", "bus", "coach", "omnibus"],
  },
  {
    key: "\uE836",
    name: "Bike",
    keywords: ["Fahrrad", "Rad", "Zweirad", "bike", "bicycle", "cycle"],
  },
  {
    key: "\u005E",
    name: "Bus",
    keywords: ["Bus", "Omnibus", "Autobus", "bus", "coach", "omnibus"],
  },
  {
    key: "\u005F",
    name: "Motorcycle",
    keywords: [
      "Motorrad",
      "Krad",
      "Zweirad",
      "motorcycle",
      "motorbike",
      "bike",
    ],
  },
  {
    key: "\u0060",
    name: "Motorcycle",
    keywords: [
      "Motorrad",
      "Krad",
      "Zweirad",
      "motorcycle",
      "motorbike",
      "bike",
    ],
  },
  {
    key: "\u0061",
    name: "Train",
    keywords: ["Zug", "Eisenbahn", "Bahn", "train", "railway", "locomotive"],
  },
  {
    key: "\u0062",
    name: "Train",
    keywords: ["Zug", "Eisenbahn", "Bahn", "train", "railway", "locomotive"],
  },
  {
    key: "\uE835",
    name: "Train",
    keywords: ["Zug", "Eisenbahn", "Bahn", "train", "railway", "locomotive"],
  },
  {
    key: "\uE846",
    name: "Train",
    keywords: ["Zug", "Eisenbahn", "Bahn", "train", "railway", "locomotive"],
  },
  {
    key: "\uE832",
    name: "Subway",
    keywords: [
      "U-Bahn",
      "Metro",
      "Untergrundbahn",
      "subway",
      "underground",
      "metro",
    ],
  },
  {
    key: "\u0063",
    name: "Ship",
    keywords: ["Schiff", "Boot", "Dampfer", "ship", "boat", "vessel"],
  },
  {
    key: "\uE826",
    name: "Boat",
    keywords: ["Boot", "Schiff", "Kahn", "boat", "ship", "vessel"],
  },
  {
    key: "\u0055",
    name: "Airplane",
    keywords: ["Flugzeug", "Flieger", "Jet", "airplane", "aircraft", "plane"],
  },
  {
    key: "\uE844",
    name: "Airplane",
    keywords: ["Flugzeug", "Flieger", "Jet", "airplane", "aircraft", "plane"],
  },
  {
    key: "\uE845",
    name: "Airplane",
    keywords: ["Flugzeug", "Flieger", "Jet", "airplane", "aircraft", "plane"],
  },
  {
    key: "\u0074",
    name: "Helicopter",
    keywords: [
      "Hubschrauber",
      "Helikopter",
      "Chopper",
      "helicopter",
      "chopper",
      "whirlybird",
    ],
  },
  {
    key: "\uE82D",
    name: "Helicopter",
    keywords: [
      "Hubschrauber",
      "Helikopter",
      "Chopper",
      "helicopter",
      "chopper",
      "whirlybird",
    ],
  },
  {
    key: "\uE847",
    name: "Gas Station",
    keywords: [
      "Tankstelle",
      "Zapfsäule",
      "Tanke",
      "gas station",
      "petrol station",
      "fuel pump",
    ],
  },

  // Buildings and Infrastructure
  {
    key: "\u0031",
    name: "Home",
    keywords: ["Zuhause", "Heim", "Wohnung", "home", "residence", "dwelling"],
  },
  {
    key: "\uE858",
    name: "House",
    keywords: ["Haus", "Gebäude", "Wohnhaus", "house", "building", "residence"],
  },
  {
    key: "\u006F",
    name: "Bank",
    keywords: [
      "Bank",
      "Geldinstitut",
      "Kreditinstitut",
      "bank",
      "financial institution",
      "credit union",
    ],
  },
  {
    key: "\uE84E",
    name: "Bank",
    keywords: [
      "Bank",
      "Geldinstitut",
      "Kreditinstitut",
      "bank",
      "financial institution",
      "credit union",
    ],
  },
  {
    key: "\u0070",
    name: "Building",
    keywords: [
      "Gebäude",
      "Bauwerk",
      "Struktur",
      "building",
      "structure",
      "edifice",
    ],
  },
  {
    key: "\u0071",
    name: "Building",
    keywords: [
      "Gebäude",
      "Bauwerk",
      "Struktur",
      "building",
      "structure",
      "edifice",
    ],
  },
  {
    key: "\uE819",
    name: "Building",
    keywords: [
      "Gebäude",
      "Bauwerk",
      "Struktur",
      "building",
      "structure",
      "edifice",
    ],
  },
  {
    key: "\uE83B",
    name: "Building",
    keywords: [
      "Gebäude",
      "Bauwerk",
      "Struktur",
      "building",
      "structure",
      "edifice",
    ],
  },
  {
    key: "\uE850",
    name: "Building",
    keywords: [
      "Gebäude",
      "Bauwerk",
      "Struktur",
      "building",
      "structure",
      "edifice",
    ],
  },
  {
    key: "\u0072",
    name: "Hospital",
    keywords: [
      "Krankenhaus",
      "Klinik",
      "Spital",
      "hospital",
      "clinic",
      "infirmary",
    ],
  },
  {
    key: "\uE80C",
    name: "Factory",
    keywords: [
      "Fabrik",
      "Werk",
      "Produktionsstätte",
      "factory",
      "plant",
      "manufacturing facility",
    ],
  },
  {
    key: "\uE82E",
    name: "Factory",
    keywords: [
      "Fabrik",
      "Werk",
      "Produktionsstätte",
      "factory",
      "plant",
      "manufacturing facility",
    ],
  },
  {
    key: "\uE830",
    name: "Tower",
    keywords: [
      "Turm",
      "Hochhaus",
      "Wolkenkratzer",
      "tower",
      "skyscraper",
      "high-rise",
    ],
  },
  {
    key: "\uE831",
    name: "Tower",
    keywords: [
      "Turm",
      "Hochhaus",
      "Wolkenkratzer",
      "tower",
      "skyscraper",
      "high-rise",
    ],
  },
  {
    key: "\uE852",
    name: "Tube",
    keywords: [
      "U-Bahn",
      "Metro",
      "Untergrundbahn",
      "tube",
      "subway",
      "underground",
    ],
  },
  {
    key: "\uE855",
    name: "Tube",
    keywords: [
      "U-Bahn",
      "Metro",
      "Untergrundbahn",
      "tube",
      "subway",
      "underground",
    ],
  },
  {
    key: "\u0057",
    name: "Road",
    keywords: ["Straße", "Weg", "Fahrbahn", "road", "street", "highway"],
  },
  {
    key: "\uE827",
    name: "Fence",
    keywords: [
      "Zaun",
      "Einzäunung",
      "Absperrung",
      "fence",
      "barrier",
      "enclosure",
    ],
  },
  {
    key: "\uE80E",
    name: "Sign",
    keywords: ["Schild", "Zeichen", "Hinweis", "sign", "signage", "indicator"],
  },
  {
    key: "\uE861",
    name: "Stop Sign",
    keywords: [
      "Stoppschild",
      "Haltezeichen",
      "Verkehrszeichen",
      "stop sign",
      "traffic sign",
      "road sign",
    ],
  },
  {
    key: "\uE814",
    name: "Parking",
    keywords: [
      "Parkplatz",
      "Parken",
      "Stellplatz",
      "parking",
      "car park",
      "lot",
    ],
  },

  // Urban Elements
  {
    key: "\uE806",
    name: "Tree",
    keywords: ["Baum", "Wald", "Natur", "tree", "forest", "nature"],
  },
  {
    key: "\uE81A",
    name: "Tree",
    keywords: ["Baum", "Wald", "Natur", "tree", "forest", "nature"],
  },
  {
    key: "\uE81B",
    name: "Tree",
    keywords: ["Baum", "Wald", "Natur", "tree", "forest", "nature"],
  },
  {
    key: "\uE818",
    name: "Plant",
    keywords: ["Pflanze", "Gewächs", "Grün", "plant", "vegetation", "greenery"],
  },
  {
    key: "\uE828",
    name: "Flower",
    keywords: ["Blume", "Blüte", "Garten", "flower", "blossom", "garden"],
  },
  {
    key: "\uE856",
    name: "Flower",
    keywords: ["Blume", "Blüte", "Garten", "flower", "blossom", "garden"],
  },
  {
    key: "\uE85B",
    name: "Leaf",
    keywords: ["Blatt", "Laub", "Herbst", "leaf", "foliage", "autumn"],
  },
  {
    key: "\uE80F",
    name: "Map",
    keywords: ["Karte", "Plan", "Navigation", "map", "plan", "navigation"],
  },
  {
    key: "\u0034",
    name: "Pin",
    keywords: ["Stecknadel", "Markierung", "Ort", "pin", "marker", "location"],
  },
  {
    key: "\uE80D",
    name: "Pin",
    keywords: ["Stecknadel", "Markierung", "Ort", "pin", "marker", "location"],
  },
  {
    key: "\u0045",
    name: "Location",
    keywords: ["Standort", "Position", "Ort", "location", "position", "place"],
  },
  {
    key: "\uE80B",
    name: "Location",
    keywords: ["Standort", "Position", "Ort", "location", "position", "place"],
  },
  {
    key: "\u0046",
    name: "Current Location",
    keywords: [
      "Aktueller Standort",
      "Hier",
      "GPS",
      "current location",
      "here",
      "GPS",
    ],
  },

  // Public Services
  {
    key: "\uE83A",
    name: "Education",
    keywords: [
      "Bildung",
      "Schule",
      "Lernen",
      "education",
      "school",
      "learning",
    ],
  },
  {
    key: "\u0078",
    name: "Education",
    keywords: [
      "Bildung",
      "Schule",
      "Lernen",
      "education",
      "school",
      "learning",
    ],
  },
  {
    key: "\u0058",
    name: "Book",
    keywords: ["Buch", "Lesen", "Literatur", "book", "reading", "literature"],
  },
  {
    key: "\uE833",
    name: "Book",
    keywords: ["Buch", "Lesen", "Literatur", "book", "reading", "literature"],
  },
  {
    key: "\uE817",
    name: "Shower",
    keywords: ["Dusche", "Bad", "Hygiene", "shower", "bathroom", "hygiene"],
  },
  {
    key: "\uE834",
    name: "Fire",
    keywords: ["Feuer", "Brand", "Flamme", "fire", "blaze", "flame"],
  },
  {
    key: "\u0076",
    name: "Ambulance",
    keywords: [
      "Krankenwagen",
      "Notfall",
      "Rettung",
      "ambulance",
      "emergency",
      "rescue",
    ],
  },
  {
    key: "\u0075",
    name: "First aid",
    keywords: [
      "Erste Hilfe",
      "Notfallversorgung",
      "Rettung",
      "first aid",
      "emergency care",
      "rescue",
    ],
  },
  {
    key: "\uE84F",
    name: "Trash",
    keywords: ["Müll", "Abfall", "Entsorgung", "trash", "waste", "disposal"],
  },
  {
    key: "\u0043",
    name: "Trash",
    keywords: ["Müll", "Abfall", "Entsorgung", "trash", "waste", "disposal"],
  },
  {
    key: "\uE842",
    name: "Trash",
    keywords: ["Müll", "Abfall", "Entsorgung", "trash", "waste", "disposal"],
  },

  // Recreation and Culture
  {
    key: "\uE81C",
    name: "Table Tennis",
    keywords: [
      "Tischtennis",
      "Ping Pong",
      "Sport",
      "table tennis",
      "ping pong",
      "sport",
    ],
  },
  {
    key: "\uE81D",
    name: "Swimming",
    keywords: [
      "Schwimmen",
      "Wassersport",
      "Badeanzug",
      "swimming",
      "water sport",
      "swimsuit",
    ],
  },
  {
    key: "\uE81E",
    name: "Skiing",
    keywords: [
      "Skifahren",
      "Wintersport",
      "Schnee",
      "skiing",
      "winter sport",
      "snow",
    ],
  },
  {
    key: "\uE83D",
    name: "Baseball",
    keywords: [
      "Baseball",
      "Schläger",
      "Ballsport",
      "baseball",
      "bat",
      "ball sport",
    ],
  },
  {
    key: "\uE840",
    name: "Baseball",
    keywords: [
      "Baseball",
      "Schläger",
      "Ballsport",
      "baseball",
      "bat",
      "ball sport",
    ],
  },
  {
    key: "\uE841",
    name: "Basketball",
    keywords: [
      "Basketball",
      "Korb",
      "Ballsport",
      "basketball",
      "hoop",
      "ball sport",
    ],
  },
  {
    key: "\uE839",
    name: "Camping",
    keywords: ["Camping", "Zelt", "Outdoor", "camping", "tent", "outdoor"],
  },
  {
    key: "\uE854",
    name: "Film",
    keywords: ["Film", "Kino", "Video", "movie", "cinema", "video"],
  },
  {
    key: "\uE84C",
    name: "Masks",
    keywords: ["Masken", "Theater", "Karneval", "masks", "theater", "carnival"],
  },
  {
    key: "\uE800",
    name: "Music Note",
    keywords: [
      "Musiknote",
      "Melodie",
      "Klang",
      "music note",
      "melody",
      "sound",
    ],
  },
  {
    key: "\uE801",
    name: "Martini Glass",
    keywords: [
      "Martiniglas",
      "Cocktail",
      "Bar",
      "martini glass",
      "cocktail",
      "bar",
    ],
  },
  {
    key: "\uE83F",
    name: "Martini Glass",
    keywords: [
      "Martiniglas",
      "Cocktail",
      "Bar",
      "martini glass",
      "cocktail",
      "bar",
    ],
  },
  {
    key: "\u006B",
    name: "Beer",
    keywords: ["Bier", "Getränk", "Brauerei", "beer", "beverage", "brewery"],
  },
  {
    key: "\uE838",
    name: "Coffee",
    keywords: ["Kaffee", "Getränk", "Café", "coffee", "beverage", "cafe"],
  },
  {
    key: "\u0068",
    name: "Coffee",
    keywords: ["Kaffee", "Getränk", "Café", "coffee", "beverage", "cafe"],
  },
  {
    key: "\uE825",
    name: "Burger",
    keywords: ["Burger", "Fastfood", "Essen", "burger", "fast food", "food"],
  },
  {
    key: "\uE80A",
    name: "Cake",
    keywords: ["Kuchen", "Dessert", "Gebäck", "cake", "dessert", "pastry"],
  },
  {
    key: "\u0069",
    name: "Cutlery",
    keywords: ["Besteck", "Gabel", "Messer", "cutlery", "fork", "knife"],
  },
  {
    key: "\uE820",
    name: "Cuttlery",
    keywords: ["Besteck", "Gabel", "Messer", "cutlery", "fork", "knife"],
  },
  {
    key: "\u007B",
    name: "Spoon",
    keywords: ["Löffel", "Besteck", "Suppe", "spoon", "cutlery", "soup"],
  },

  // People and Community
  {
    key: "\u0023",
    name: "Man",
    keywords: ["Mann", "Herr", "Männlich", "man", "gentleman", "male"],
  },
  {
    key: "\u0024",
    name: "Woman",
    keywords: ["Frau", "Dame", "Weiblich", "woman", "lady", "female"],
  },
  {
    key: "\u0025",
    name: "Person",
    keywords: [
      "Person",
      "Mensch",
      "Individuum",
      "person",
      "human",
      "individual",
    ],
  },
  {
    key: "\uE823",
    name: "Person",
    keywords: [
      "Person",
      "Mensch",
      "Individuum",
      "person",
      "human",
      "individual",
    ],
  },
  {
    key: "\uE824",
    name: "Person",
    keywords: [
      "Person",
      "Mensch",
      "Individuum",
      "person",
      "human",
      "individual",
    ],
  },
  {
    key: "\u0026",
    name: "Group",
    keywords: ["Gruppe", "Team", "Gemeinschaft", "group", "team", "community"],
  },
  {
    key: "\u0027",
    name: "User",
    keywords: ["Benutzer", "Nutzer", "Konto", "user", "account", "profile"],
  },
  {
    key: "\u0028",
    name: "Add User",
    keywords: [
      "Benutzer hinzufügen",
      "Registrieren",
      "Anmelden",
      "add user",
      "register",
      "sign up",
    ],
  },
  {
    key: "\u0029",
    name: "Remove User",
    keywords: [
      "Benutzer entfernen",
      "Löschen",
      "Abmelden",
      "remove user",
      "delete",
      "sign out",
    ],
  },
  {
    key: "\uE81F",
    name: "Children",
    keywords: [
      "Kinder",
      "Jugendliche",
      "Nachwuchs",
      "children",
      "youth",
      "offspring",
    ],
  },
  {
    key: "\uE84D",
    name: "Children",
    keywords: [
      "Kinder",
      "Jugendliche",
      "Nachwuchs",
      "children",
      "youth",
      "offspring",
    ],
  },
  {
    key: "\uE812",
    name: "Elderly",
    keywords: [
      "Senioren",
      "Ältere",
      "Rentner",
      "elderly",
      "seniors",
      "retirees",
    ],
  },
  {
    key: "\u006C",
    name: "Wheelchair",
    keywords: [
      "Rollstuhl",
      "Mobilität",
      "Barrierefreiheit",
      "wheelchair",
      "mobility",
      "accessibility",
    ],
  },
  {
    key: "\uE813",
    name: "Wheelchair",
    keywords: [
      "Rollstuhl",
      "Mobilität",
      "Barrierefreiheit",
      "wheelchair",
      "mobility",
      "accessibility",
    ],
  },
  {
    key: "\uE857",
    name: "Accessibility",
    keywords: [
      "Barrierefreiheit",
      "Zugänglichkeit",
      "Inklusion",
      "accessibility",
      "inclusivity",
      "universal design",
    ],
  },

  // Communication and Information
  {
    key: "\u0021",
    name: "Envelope",
    keywords: ["Brief", "Post", "Nachricht", "letter", "mail", "message"],
  },
  {
    key: "\uE851",
    name: "Envelope",
    keywords: ["Brief", "Post", "Nachricht", "letter", "mail", "message"],
  },
  {
    key: "\u003E",
    name: "Speech Bubble",
    keywords: [
      "Sprechblase",
      "Dialog",
      "Kommunikation",
      "speech bubble",
      "dialog",
      "communication",
    ],
  },
  {
    key: "\u003F",
    name: "Speech Bubbles",
    keywords: [
      "Sprechblasen",
      "Gespräch",
      "Diskussion",
      "speech bubbles",
      "conversation",
      "discussion",
    ],
  },
  {
    key: "\u0040",
    name: "Bell",
    keywords: [
      "Glocke",
      "Benachrichtigung",
      "Alarm",
      "bell",
      "notification",
      "alert",
    ],
  },
  {
    key: "\u005A",
    name: "Megaphone",
    keywords: [
      "Megafon",
      "Lautsprecher",
      "Ankündigung",
      "megaphone",
      "loudspeaker",
      "announcement",
    ],
  },
  {
    key: "\u0047",
    name: "Phone",
    keywords: [
      "Telefon",
      "Anruf",
      "Kommunikation",
      "phone",
      "call",
      "communication",
    ],
  },
  {
    key: "\uE815",
    name: "Phone",
    keywords: [
      "Telefon",
      "Anruf",
      "Kommunikation",
      "phone",
      "call",
      "communication",
    ],
  },
  {
    key: "\u002A",
    name: "Camera",
    keywords: ["Kamera", "Foto", "Bild", "camera", "photo", "image"],
  },
  {
    key: "\uE807",
    name: "Binoculars",
    keywords: [
      "Fernglas",
      "Beobachtung",
      "Suche",
      "binoculars",
      "observation",
      "search",
    ],
  },
  {
    key: "\u002F",
    name: "Question Mark",
    keywords: [
      "Fragezeichen",
      "Frage",
      "Hilfe",
      "question mark",
      "question",
      "help",
    ],
  },
  {
    key: "\u0030",
    name: "Information",
    keywords: [
      "Information",
      "Auskunft",
      "Hinweis",
      "information",
      "details",
      "notice",
    ],
  },

  // Safety and Security
  {
    key: "\u0032",
    name: "Lock",
    keywords: [
      "Schloss",
      "Sicherheit",
      "Schutz",
      "lock",
      "security",
      "protection",
    ],
  },
  {
    key: "\u0033",
    name: "Unlock",
    keywords: ["Entsperren", "Öffnen", "Zugang", "unlock", "open", "access"],
  },
  {
    key: "\u0035",
    name: "Eye",
    keywords: ["Auge", "Sehen", "Beobachten", "eye", "see", "observe"],
  },
  {
    key: "\u0036",
    name: "Eye Crossed",
    keywords: [
      "Durchgestrichenes Auge",
      "Verbergen",
      "Privatsphäre",
      "crossed eye",
      "hide",
      "privacy",
    ],
  },
  {
    key: "\u0041",
    name: "Warning",
    keywords: ["Warnung", "Vorsicht", "Achtung", "warning", "caution", "alert"],
  },
  {
    key: "\u0042",
    name: "Exclamation",
    keywords: [
      "Ausrufezeichen",
      "Wichtig",
      "Dringend",
      "exclamation",
      "important",
      "urgent",
    ],
  },
  {
    key: "\u002D",
    name: "Stop Sign",
    keywords: [
      "Stoppschild",
      "Anhalten",
      "Verkehr",
      "stop sign",
      "halt",
      "traffic",
    ],
  },

  // Nature and Environment
  {
    key: "\uE829",
    name: "Giraffe",
    keywords: ["Giraffe", "Safari", "Tier", "giraffe", "safari", "animal"],
  },
  {
    key: "\uE85A",
    name: "Dog",
    keywords: ["Hund", "Haustier", "Welpe", "dog", "pet", "puppy"],
  },
  {
    key: "\u0079",
    name: "Paw",
    keywords: [
      "Pfote",
      "Tatze",
      "Tierspur",
      "paw",
      "animal track",
      "footprint",
    ],
  },
  {
    key: "\uE85F",
    name: "Elephant",
    keywords: ["Elefant", "Rüssel", "Savanne", "elephant", "trunk", "savanna"],
  },
  {
    key: "\u0059",
    name: "Water Drop",
    keywords: [
      "Wassertropfen",
      "Flüssigkeit",
      "Feuchtigkeit",
      "water drop",
      "liquid",
      "moisture",
    ],
  },
  {
    key: "\u007A",
    name: "Recycling",
    keywords: [
      "Recycling",
      "Umweltschutz",
      "Nachhaltigkeit",
      "recycling",
      "environmental protection",
      "sustainability",
    ],
  },

  // Commerce and Finance
  {
    key: "\u0048",
    name: "Shopping Cart",
    keywords: [
      "Einkaufswagen",
      "Warenkorb",
      "Einkauf",
      "shopping cart",
      "checkout",
      "purchase",
    ],
  },
  {
    key: "\uE82B",
    name: "Cart",
    keywords: ["Wagen", "Karren", "Einkaufswagen", "cart", "trolley", "buggy"],
  },
  {
    key: "\uE810",
    name: "Basket",
    keywords: [
      "Korb",
      "Einkaufskorb",
      "Warenkorb",
      "basket",
      "shopping basket",
      "hamper",
    ],
  },
  {
    key: "\uE811",
    name: "Bag",
    keywords: [
      "Tasche",
      "Einkaufstasche",
      "Beutel",
      "bag",
      "shopping bag",
      "tote",
    ],
  },
  {
    key: "\uE84B",
    name: "Bag",
    keywords: [
      "Tasche",
      "Einkaufstasche",
      "Beutel",
      "bag",
      "shopping bag",
      "tote",
    ],
  },
  {
    key: "\u0064",
    name: "Money",
    keywords: ["Geld", "Währung", "Finanzen", "money", "currency", "finance"],
  },
  {
    key: "\u0065",
    name: "Euro",
    keywords: ["Euro", "Währung", "Geld", "euro", "currency", "money"],
  },
  {
    key: "\u0066",
    name: "Dollar",
    keywords: ["Dollar", "Währung", "Geld", "dollar", "currency", "money"],
  },
  {
    key: "\uE83C",
    name: "Credit card",
    keywords: [
      "Kreditkarte",
      "Zahlungskarte",
      "Plastikgeld",
      "credit card",
      "payment card",
      "plastic money",
    ],
  },

  // Miscellaneous
  {
    key: "\u0022",
    name: "Star",
    keywords: ["Stern", "Favorit", "Auszeichnung", "star", "favorite", "award"],
  },
  {
    key: "\uE859",
    name: "Star",
    keywords: ["Stern", "Favorit", "Auszeichnung", "star", "favorite", "award"],
  },
  {
    key: "\uE84A",
    name: "Star",
    keywords: ["Stern", "Favorit", "Auszeichnung", "star", "favorite", "award"],
  },
  {
    key: "\u002B",
    name: "Checkmark",
    keywords: [
      "Häkchen",
      "Bestätigung",
      "Erledigt",
      "checkmark",
      "confirmation",
      "done",
    ],
  },
  {
    key: "\u002C",
    name: "Close",
    keywords: ["Schließen", "Abbrechen", "Beenden", "close", "cancel", "exit"],
  },
  {
    key: "\u002E",
    name: "Add",
    keywords: ["Hinzufügen", "Neu", "Erstellen", "add", "new", "create"],
  },
  {
    key: "\u0037",
    name: "Tag",
    keywords: [
      "Etikett",
      "Markierung",
      "Kennzeichnung",
      "tag",
      "label",
      "marker",
    ],
  },
  {
    key: "\u0038",
    name: "Bookmark",
    keywords: [
      "Lesezeichen",
      "Merken",
      "Speichern",
      "bookmark",
      "save",
      "remember",
    ],
  },
  {
    key: "\u0039",
    name: "Flag",
    keywords: [
      "Flagge",
      "Markierung",
      "Kennzeichnung",
      "flag",
      "marker",
      "indicator",
    ],
  },
  {
    key: "\uE816",
    name: "Flag",
    keywords: [
      "Flagge",
      "Markierung",
      "Kennzeichnung",
      "flag",
      "marker",
      "indicator",
    ],
  },
  {
    key: "\uE82A",
    name: "Flag",
    keywords: [
      "Flagge",
      "Markierung",
      "Kennzeichnung",
      "flag",
      "marker",
      "indicator",
    ],
  },
  {
    key: "\uE83E",
    name: "Flag",
    keywords: [
      "Flagge",
      "Markierung",
      "Kennzeichnung",
      "flag",
      "marker",
      "indicator",
    ],
  },
  {
    key: "\u003A",
    name: "Thumbs Up",
    keywords: [
      "Daumen hoch",
      "Zustimmung",
      "Gefällt mir",
      "thumbs up",
      "approval",
      "like",
    ],
  },
  {
    key: "\u003B",
    name: "Thumbs Down",
    keywords: [
      "Daumen runter",
      "Ablehnung",
      "Gefällt mir nicht",
      "thumbs down",
      "disapproval",
      "dislike",
    ],
  },
  {
    key: "\u003C",
    name: "Pencil",
    keywords: ["Stift", "Bearbeiten", "Schreiben", "pencil", "edit", "write"],
  },
  {
    key: "\u003D",
    name: "Game",
    keywords: [
      "Spiel",
      "Unterhaltung",
      "Freizeit",
      "game",
      "entertainment",
      "leisure",
    ],
  },
  {
    key: "\u0044",
    name: "Heart",
    keywords: ["Herz", "Liebe", "Favorit", "heart", "love", "favorite"],
  },
  {
    key: "\u0077",
    name: "Heart",
    keywords: ["Herz", "Liebe", "Favorit", "heart", "love", "favorite"],
  },
  {
    key: "\u0049",
    name: "Filter",
    keywords: [
      "Filter",
      "Sortieren",
      "Einschränken",
      "filter",
      "sort",
      "narrow down",
    ],
  },
  {
    key: "\u004A",
    name: "Wrench",
    keywords: [
      "Schraubenschlüssel",
      "Werkzeug",
      "Reparatur",
      "wrench",
      "tool",
      "repair",
    ],
  },
  {
    key: "\u004B",
    name: "Setting",
    keywords: [
      "Einstellung",
      "Konfiguration",
      "Option",
      "setting",
      "configuration",
      "option",
    ],
  },
  {
    key: "\u004C",
    name: "Settings",
    keywords: [
      "Einstellungen",
      "Optionen",
      "Konfiguration",
      "settings",
      "options",
      "configuration",
    ],
  },
  {
    key: "\u004D",
    name: "Calendar",
    keywords: [
      "Kalender",
      "Datum",
      "Termin",
      "calendar",
      "date",
      "appointment",
    ],
  },
  {
    key: "\u004E",
    name: "Calendar",
    keywords: [
      "Kalender",
      "Datum",
      "Termin",
      "calendar",
      "date",
      "appointment",
    ],
  },
  {
    key: "\u004F",
    name: "Volume",
    keywords: ["Lautstärke", "Audio", "Ton", "volume", "audio", "sound"],
  },
  {
    key: "\u0050",
    name: "Volume Low",
    keywords: [
      "Leise",
      "Niedriger Ton",
      "Audio",
      "low volume",
      "quiet",
      "audio",
    ],
  },
  {
    key: "\u0051",
    name: "Volume Off",
    keywords: ["Stumm", "Ton aus", "Lautlos", "mute", "sound off", "silent"],
  },
  {
    key: "\u0052",
    name: "Clock",
    keywords: ["Uhr", "Zeit", "Termin", "clock", "time", "appointment"],
  },
  {
    key: "\u0053",
    name: "Lightbulb",
    keywords: [
      "Glühbirne",
      "Idee",
      "Erleuchtung",
      "lightbulb",
      "idea",
      "insight",
    ],
  },
  {
    key: "\u0054",
    name: "Trophy",
    keywords: ["Trophäe", "Auszeichnung", "Sieg", "trophy", "award", "victory"],
  },
  {
    key: "\u0056",
    name: "Briefcase",
    keywords: [
      "Aktentasche",
      "Arbeit",
      "Geschäft",
      "briefcase",
      "work",
      "business",
    ],
  },
  {
    key: "\u005B",
    name: "Present",
    keywords: [
      "Geschenk",
      "Überraschung",
      "Gabe",
      "present",
      "gift",
      "surprise",
    ],
  },
  {
    key: "\u005C",
    name: "Magic",
    keywords: ["Magie", "Zauberei", "Trick", "magic", "sorcery", "trick"],
  },
  {
    key: "\u005D",
    name: "Test Tube",
    keywords: [
      "Reagenzglas",
      "Experiment",
      "Labor",
      "test tube",
      "experiment",
      "laboratory",
    ],
  },
  {
    key: "\u0067",
    name: "Gavel",
    keywords: ["Hammer", "Gericht", "Auktion", "gavel", "court", "auction"],
  },
  {
    key: "\u006A",
    name: "Palette",
    keywords: ["Palette", "Farben", "Kunst", "palette", "colors", "art"],
  },
  {
    key: "\uE843",
    name: "Palette",
    keywords: ["Palette", "Farben", "Kunst", "palette", "colors", "art"],
  },
  {
    key: "\u006D",
    name: "Puzzle Piece",
    keywords: [
      "Puzzleteil",
      "Rätsel",
      "Lösung",
      "puzzle piece",
      "riddle",
      "solution",
    ],
  },
  {
    key: "\u006E",
    name: "Anchor",
    keywords: ["Anker", "Schiff", "Hafen", "anchor", "ship", "harbor"],
  },
  {
    key: "\uE82C",
    name: "Anchor",
    keywords: ["Anker", "Schiff", "Hafen", "anchor", "ship", "harbor"],
  },
  {
    key: "\u0073",
    name: "Bed",
    keywords: ["Bett", "Schlaf", "Erholung", "bed", "sleep", "rest"],
  },
  {
    key: "\uE82F",
    name: "Bed",
    keywords: ["Bett", "Schlaf", "Erholung", "bed", "sleep", "rest"],
  },
  {
    key: "\u007C",
    name: "Box",
    keywords: ["Kiste", "Paket", "Behälter", "box", "package", "container"],
  },
  {
    key: "\uE860",
    name: "Box",
    keywords: ["Kiste", "Paket", "Behälter", "box", "package", "container"],
  },
  {
    key: "\u007D",
    name: "Boxes",
    keywords: ["Kisten", "Pakete", "Lager", "boxes", "packages", "storage"],
  },
  {
    key: "\u007E",
    name: "Stack",
    keywords: ["Stapel", "Haufen", "Anordnung", "stack", "pile", "arrangement"],
  },
  {
    key: "\uE802",
    name: "Circle",
    keywords: ["Kreis", "Rund", "Form", "circle", "round", "shape"],
  },
  {
    key: "\uE808",
    name: "Ball",
    keywords: ["Ball", "Kugel", "Sport", "ball", "sphere", "sport"],
  },
  {
    key: "\uE809",
    name: "Brush",
    keywords: ["Pinsel", "Malen", "Kunst", "brush", "paint", "art"],
  },
  {
    key: "\uE822",
    name: "Cross",
    keywords: ["Kreuz", "Abbrechen", "Schließen", "cross", "cancel", "close"],
  },
  {
    key: "\uE848",
    name: "Lips",
    keywords: ["Lippen", "Kuss", "Sprechen", "lips", "kiss", "speak"],
  },
  {
    key: "\uE849",
    name: "Moon Star",
    keywords: [
      "Mond und Stern",
      "Nacht",
      "Himmel",
      "moon and star",
      "night",
      "sky",
    ],
  },
  {
    key: "\uE853",
    name: "Crown",
    keywords: ["Krone", "Königlich", "Auszeichnung", "crown", "royal", "award"],
  },
  {
    key: "\uE85C",
    name: "Rectangle",
    keywords: [
      "Rechteck",
      "Form",
      "Geometrie",
      "rectangle",
      "shape",
      "geometry",
    ],
  },
  {
    key: "\uE85D",
    name: "Rectangle",
    keywords: [
      "Rechteck",
      "Form",
      "Geometrie",
      "rectangle",
      "shape",
      "geometry",
    ],
  },
  {
    key: "\uE85E",
    name: "Rectangle",
    keywords: [
      "Rechteck",
      "Form",
      "Geometrie",
      "rectangle",
      "shape",
      "geometry",
    ],
  },
];
